// Use this directive on elements that contain highcharts and require size updates when the layout changes

angular.module('vrm.components')
    .directive('vrmHighcharts', vrmHighcharts);

/* @ngInject */
function vrmHighcharts() {
    return {
        restrict: 'A',
        link: ($scope, $element) => {
            if (!window.MutationObserver) return;

            const observer = new MutationObserver(handleMutation);
            const elem = angular.element($element)[0];
            observer.observe(elem, {
                subtree: true,
                attributeFilter: ['class', 'style'],
            });

            function handleMutation() {
                $scope.$broadcast('highchartsng.reflow');
            }

            function cleanUp() {
                observer.disconnect();
            }

            $scope.$on('$destroy', cleanUp);
        },
    };
}
